// extracted by mini-css-extract-plugin
module.exports = {"video-iframe":"VideoPlayer_video-iframe__t6ic8","big":"VideoPlayer_big__I62Y7"};